import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface UrgencyCodesResponse {
  urgencyCodes: { code: string; label: string }[];
}

export const useReferUrgencyCodes = () => {
  return useApi<UrgencyCodesResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<UrgencyCodesResponse>(
          "/amazon-clinic/care-plans/refer-out/urgency-codes",
        );

        return response.data;
      },
      queryKey: QueryKeys.Reference.Referrals.URGENCY_CODES,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
};
